import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Shield, Phone, Globe, Mail } from 'lucide-react';

export default function FairHousing() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-sky-100 rounded-xl">
              <Shield className="w-7 h-7 text-sky-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800">Fair Housing Policy</h1>
              <p className="text-slate-500 text-sm">Equal Opportunity Housing</p>
            </div>
          </div>

          <div className="space-y-6 text-slate-600 leading-relaxed">
            <p>
              RoomHora is committed to ensuring that housing is available to all persons regardless of race, color,
              religion, sex (including gender identity and sexual orientation), national origin, disability, or familial
              status in accordance with the <strong>Fair Housing Act (Title VIII of the Civil Rights Act of 1968)</strong>.
            </p>

            <div>
              <h2 className="text-lg font-semibold text-slate-800 mb-3">Our Commitment</h2>
              <p>
                We pledge to uphold the letter and spirit of U.S. policy for the achievement of equal housing opportunity
                throughout the nation. We encourage and support an affirmative advertising and marketing program in which
                there are no barriers to obtaining housing because of race, color, religion, sex, handicap, familial status,
                or national origin.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-800 mb-3">Protected Classes</h2>
              <p className="mb-3">Under the Fair Housing Act, it is illegal to discriminate based on:</p>
              <ul className="space-y-2">
                {[
                  'Race or Color',
                  'Religion',
                  'Sex (including gender identity and sexual orientation)',
                  'National Origin',
                  'Disability (physical or mental)',
                  'Familial Status (families with children under 18)',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <div className="w-1.5 h-1.5 bg-sky-500 rounded-full mt-2 shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-sm text-slate-500">
                Many states and localities also protect additional classes such as age, marital status, sexual orientation,
                gender identity, source of income, military/veteran status, and others.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-800 mb-3">For Property Owners</h2>
              <p>
                Property owners and managers using RoomHora must comply with all applicable fair housing laws.
                Listing descriptions must not include discriminatory language or preferences based on protected classes.
                RoomHora reserves the right to remove any listing that violates fair housing guidelines.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-800 mb-3">Reasonable Accommodations</h2>
              <p>
                Under the Fair Housing Act, property owners and managers are required to make reasonable accommodations
                in rules, policies, practices, or services to afford persons with disabilities an equal opportunity to
                use and enjoy a dwelling.
              </p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
              <h2 className="text-lg font-semibold text-slate-800 mb-3">Report Discrimination</h2>
              <p className="mb-4">
                If you believe you have been a victim of housing discrimination, you can file a complaint with:
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Globe className="w-5 h-5 text-sky-500 shrink-0" />
                  <span>U.S. Department of Housing and Urban Development (HUD) — <a href="https://www.hud.gov/fairhousing" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline">hud.gov/fairhousing</a></span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-sky-500 shrink-0" />
                  <span>HUD Hotline: <a href="tel:18006699777" className="text-sky-600 hover:underline">1-800-669-9777</a></span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-sky-500 shrink-0" />
                  <span>RoomHora Support: <a href="mailto:roomhora@gmail.com" className="text-sky-600 hover:underline">roomhora@gmail.com</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
